<template>
    <section class="l-section l-section--main o-cartMobileWeek">
        <div
            class="l-container l-container--main"
            v-if="customer && currentAddress"
        >
            <div class="l-container o-cartMobileWeek__header">
                <div class="l-row l-row--touch o-cartMobileWeek__columns">
                    <div class="l-row__column o-cartMobileWeek__column">
                        <p class="a-label o-cartMobileWeek__label">Adres dostawy</p>
                        <p class="a-tabs__address">{{ currentAddress.street }} {{ currentAddress.number }}</p>
                        <p class="a-tabs__address">{{ currentAddress.postcode }} {{ currentAddress.city }}</p>
                    </div>
                    <div class="l-row__column o-cartMobileWeek__column">
                        <p class="a-label o-cartMobileWeek__label">Wartość zamówienia</p>
                        <p
                            v-if="!isNaN(weekAmount)"
                            class="a-tabs__price a-price a-price--small o-cartMobileWeek__price"
                        >
                            <span class="a-price__price">{{ weekAmount.toFixed(2).toPLN() }} </span>
                            <span class="a-tabs__priceTime a-price__time">/ 7 dni</span>
                        </p>
                        <p
                            v-if="!isNaN(monthAmount)"
                            class="a-tabs__price a-price a-price--small o-cartMobileWeek__price"
                        >{{ monthAmount.toFixed(2).toPLN() }} <span class="a-tabs__priceTime a-price__time">/ 1 mc</span></p>
                    </div>
                </div>
            </div>
            <div
                v-if="externalSupplier"
                class="l-row"
            >
                <div class="l-row__column o-cart__message">
                    <article
                        class="o-notifications__notification o-notifications__notification--danger"
                    >
                        <div class="o-notifications__notificationBody o-cart__messageText">
                            <p>{{ externalSupplierMessage }}</p>
                        </div>
                    </article>
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column">
                    <p class="m-summary__label a-label a-label--big">Podaj datę pierwszej dostawy</p>
                    <date-range-picker
                        class="o-cartMobileWeek__dateRange"
                        ref="picker"
                        :show-dropdowns="true"
                        :auto-apply="true"
                        :ranges="false"
                        :locale-data="localeData"
                        v-model="dateRange"
                        :append-to-body="true"
                        :single-date-picker="true"
                        :date-format="dateFormat"
                        control-container-class="a-control__input m-summary__dateRange"
                    >
                        <template
                            v-if="dateRange"
                            v-slot:input="picker"
                        >
                            {{ formatDate(picker.startDate) }}
                        </template>
                    </date-range-picker>
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <cart-week />
                </div>
                <div class="l-row__column">
                    <featured-products />
                </div>
            </div>
            <products-modal />
            <div class="a-mobile__buttons">
                <a-button
                    class="a-button--fullwidth"
                    @click="$router.push({ name: 'cart-mobile-summary'})"
                >
                    Powrót do listy adresów
                </a-button>
                <button
                    class="m-summary__button a-button a-button--secondary"
                    @click="handleSubmit"
                    :disabled="totalAmountValue === 0"
                >
                    Podsumowanie
                    <svg class="a-button__icon" width="6" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.625 7l3.328-2.958-3.328-2.959" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import CartWeek from '@/components/CartWeek'
import ProductsModal from '@/components/ProductsModal'
import FeaturedProducts from '@/components/FeaturedProducts'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: {
        CartWeek,
        ProductsModal,
        FeaturedProducts,
        DateRangePicker
    },
    metaInfo: {
        title: 'Koszyk'
    },
    computed: {
        currentAddress() {
            return this.$store.getters.customerAddress(this.currentAddressId)
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        customer() {
            return this.$store.getters.customer
        },
        totalAmountValue() {
            return this.$store.getters.totalAmount
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        weekAmount() {
            return this.$store.getters.weekAmount(this.currentAddressId)
        },
        monthAmount() {
            return (this.$store.getters.weekAmount(this.currentAddressId) * 4)
        },
        currentWarehouseId() {
            const warehouse = this.$store.getters.customerAddressField(this.currentAddressId, 'warehouse')
            if(typeof warehouse === 'object') {
                return Object.prototype.hasOwnProperty.call(warehouse, 'id') ? warehouse.id : false
            } else {
                return false
            }
        },
        currentCompanySize() {
            return this.$store.getters.customerAddressField(this.currentAddressId, 'companySize')
        },
        externalSupplier() {
            const warehouse = this.$store.getters.customerAddressField(this.currentAddressId, 'warehouse')
            if(warehouse) {
                return warehouse.external_supplier ? 1 : 0
            } else {
                return false
            }
        },
        externalSupplierMessage() {
            return this.$store.getters.externalSupplierMessage
        },
        dateRange: {
            get() {
                const date = this.$store.getters.customerAddressField(this.currentAddressId, 'dateFrom')
                return {
                    startDate: date,
                    endDate: date
                }
            },
            set(dateRange) {
                this.$store.dispatch('setCustomerAddressField', {
                    addressId: this.currentAddressId,
                    field: 'dateFrom',
                    value: moment(dateRange.startDate).format('YYYY-MM-DD')
                })
            }
        },
        localeData() {
            return {
                firstDay: 1,
                format: 'DD-MM-YYYY',
                daysOfWeek: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
            }
        },
        offDays() {
            return this.$store.getters.offDays
        },
        minimumDate() {
            return this.$store.getters.minimumDate
        },
        maximumDate() {
            return this.$store.getters.maximumDate
        }
    },
    methods: {
        handleResize() {
            // on touch redirect to nested route
            if(window.innerWidth > 1024) {
                this.$router.push({ name: 'cart' })
            }
        },
        handleSubmit() {
            this.$store.dispatch('fetchSettings').then(() => {
                this.$store.dispatch('checkMinimumCartDate')
            })
            // if minimum value is not reached
            const minimumValueNotReached = this.customerAddresses.some((address, idx) => {
                // if day with order
                for(let day = 0; day < 5; day++) {
                    if(this.$store.getters.isValueMinimum(day, idx)) {
                        return true
                    }
                }
            })
            if(minimumValueNotReached) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Minimum logistyczne nie zostało osiągnięte',
                    limit: 0
                })
            } else {
                this.$router.push({ name: 'checkout' })
            }
        },
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },
        dateFormat(classes, date) {
            classes.disabled = moment(date).isBefore(this.minimumDate) || this.offDays.includes(moment(date).format('YYYY-MM-DD')) || moment(date).isAfter(this.maximumDate)
            return classes
        },
        updateMinimumValue() {
            if(this.minimumDate !== null && this.minimumDate !== undefined) {
                if(moment(this.dateRange.startDate).isBefore(this.minimumDate)) {
                    this.$store.dispatch('setCustomerAddressField', {
                        addressId: this.currentAddressId,
                        field: 'dateFrom',
                        value: this.minimumDate
                    })
                }
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.$store.dispatch('fetchOffDays')
        this.updateMinimumValue()
        // get app state
        this.$store.dispatch('fetchPricelists').then(() => {
            if(typeof this.currentWarehouseId === 'number') {
                for(const customerAddress of this.customerAddresses) {
                    const warehouseId = customerAddress.warehouse.id
                    const externalSupplier = customerAddress.warehouse.external_supplier ? 1 : 0
                    const companySize = customerAddress.companySize
                    this.$store.dispatch('fetchPackageCategories', {
                        warehouseId: warehouseId,
                        externalSupplier: externalSupplier
                    })
                    this.$store.dispatch('fetchPackages', {
                        warehouseId: warehouseId,
                        externalSupplier: externalSupplier
                    })
                    this.$store.dispatch('fetchFeaturedPackages', {
                        warehouseId: warehouseId,
                        companySize: companySize,
                        externalSupplier: externalSupplier
                    })
                }
                this.$store.dispatch('fetchDiscountCategories')
                this.$store.dispatch('fetchDiscounts')
                this.$store.dispatch('fetchSettings')
            }
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
